<script>
export default {
  mounted() {
    document.title = 'Smallakes Utopia - 404'
  }
}
</script>
<template>
  <div class="container">
    <div class="row my-5">
      <div class="col-12 text-center">
        <h1>404</h1>
        <p>Page not found</p>
        <a href="/">Go back home</a>
      </div>
    </div>
  </div>
</template>